var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShield(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 115,
    viewBox: "0 0 103 115",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M101.443 16.0947C101.237 14.612 100.17 13.3924 98.7277 12.9915L52.5072 0.137549C51.8483 -0.0458497 51.1522 -0.0458497 50.4928 0.137549L4.27234 12.9915C2.8302 13.3924 1.76338 14.6115 1.55693 16.0947C1.28885 18.0224 -4.82694 63.5694 10.8597 86.2277C26.5277 108.859 49.6415 114.659 50.6176 114.895C50.9077 114.965 51.2034 114.999 51.5 114.999C51.7967 114.999 52.0923 114.964 52.3824 114.895C53.3591 114.659 76.4728 108.859 92.1404 86.2277C107.827 63.5699 101.711 18.0229 101.443 16.0947ZM81.3063 42.6855L49.7793 74.2126C49.0457 74.9462 48.0836 75.3135 47.122 75.3135C46.1604 75.3135 45.1983 74.9467 44.4647 74.2126L24.9718 54.7197C24.2668 54.0152 23.8709 53.0591 23.8709 52.0624C23.8709 51.0658 24.2673 50.1097 24.9718 49.4052L28.8422 45.5347C30.3099 44.0676 32.6896 44.067 34.1568 45.5347L47.122 58.4999L72.1213 33.5001C72.8259 32.795 73.7819 32.3992 74.7786 32.3992C75.7753 32.3992 76.7314 32.795 77.4359 33.5001L81.3063 37.3705C82.774 38.8382 82.774 41.2178 81.3063 42.6855Z",
    fill: "#C32A7C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShield);
export default __webpack_public_path__ + "static/media/shield.b7c2613aea3c73616966f1d0d886f8fb.svg";
export { ForwardRef as ReactComponent };